import { render } from "./BlogInner.vue?vue&type=template&id=6ec56670&scoped=true"
import script from "./BlogInner.vue?vue&type=script&lang=js"
export * from "./BlogInner.vue?vue&type=script&lang=js"

import "./BlogInner.vue?vue&type=style&index=0&id=6ec56670&scoped=true&lang=css"

import exportComponent from "/Users/sanzharzhubatkan/Sanzhar/Work/EduCenter/local-projects/educenter-update/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec56670"]])

export default __exports__